import type { FC, ReactNode } from "react";

import { Skeleton } from "@recobra/ui/skeleton";

/** Fixed header band of a full-height record page (case, client, user): identity, key details, record actions, and the page tabs. */
export const DetailPageHeader: FC<{
  isLoading?: boolean;
  /** Visual identity shown before the title, e.g. a person's avatar. */
  media?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  meta?: ReactNode;
  details?: ReactNode;
  actions?: ReactNode;
  tabs?: ReactNode;
}> = ({ isLoading = false, media, title, description, meta, details, actions, tabs }) => (
  <header className="flex shrink-0 flex-col gap-2 px-4 pt-4">
    <div className="flex flex-col gap-3 md:flex-row md:items-start md:gap-6">
      <div className="flex min-w-0 flex-1 items-start gap-6">
        {isLoading ? null : media}
        {isLoading ? (
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-6 w-72" />
            <Skeleton className="h-4 w-48" />
          </div>
        ) : (
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <h1 className="truncate font-heading text-base font-medium">{title}</h1>
            {description ? (
              <div className="text-sm text-muted-foreground">{description}</div>
            ) : null}
            {meta ? (
              <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-2">{meta}</div>
            ) : null}
          </div>
        )}
      </div>
      {isLoading ? null : details}
      {actions ? (
        <div className="flex shrink-0 flex-col items-start gap-2 md:items-end">{actions}</div>
      ) : null}
    </div>
    {tabs}
  </header>
);
